/* tslint:disable */
/* eslint-disable */
/**
 * Ankieter API
 * Ankieter 6.0 - the API contract, source of truth for the backend and the frontend
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CategoryStatisticsDto } from '../models';
// @ts-ignore
import type { ProblemDetailDto } from '../models';
// @ts-ignore
import type { QuestionRankingPageDto } from '../models';
// @ts-ignore
import type { QuestionStatisticsDto } from '../models';
// @ts-ignore
import type { QuestionTypeDto } from '../models';
/**
 * QuestionStatisticsApi - axios parameter creator
 * @export
 */
export const QuestionStatisticsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Every question rankQuestions finds for these filters, on all its pages and in its order, on the sheet \"pytania\"; the categories as listCategoryStatistics gives them, for the same period, test and type, on the sheet \"kategorie\".
         * @summary The ranking and the categories as a spreadsheet
         * @param {string} [fromMonth] The first month counted, as 2026-01. Leave it out to count from the start.
         * @param {string} [toMonth] The last month counted, whole. Leave it out to count up to now.
         * @param {string} [testId] Only attempts at this test.
         * @param {string} [categoryId] 
         * @param {QuestionTypeDto} [type] 
         * @param {number} [minAsked] 
         * @param {string} [locale] Language of the wording, where the version has it; otherwise its source language. A tag of a real language, such as pl or pt-BR.
         * @param {string} [sort] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportQuestionRanking: async (fromMonth?: string, toMonth?: string, testId?: string, categoryId?: string, type?: QuestionTypeDto, minAsked?: number, locale?: string, sort?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/questions/statistics/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fromMonth !== undefined) {
                localVarQueryParameter['fromMonth'] = fromMonth;
            }

            if (toMonth !== undefined) {
                localVarQueryParameter['toMonth'] = toMonth;
            }

            if (testId !== undefined) {
                localVarQueryParameter['testId'] = testId;
            }

            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (minAsked !== undefined) {
                localVarQueryParameter['minAsked'] = minAsked;
            }

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Counted as for rankQuestions. Versions newest first, only those asked in the period. A choice question has, for each version, how many times each answer was chosen. A question not asked yet answers with zeros and no versions.
         * @summary How one question fares, in all and version by version
         * @param {string} questionId 
         * @param {string} [fromMonth] The first month counted, as 2026-01. Leave it out to count from the start.
         * @param {string} [toMonth] The last month counted, whole. Leave it out to count up to now.
         * @param {string} [testId] Only attempts at this test.
         * @param {string} [locale] Language of the wording, where the version has it; otherwise its source language. A tag of a real language, such as pl or pt-BR.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionStatistics: async (questionId: string, fromMonth?: string, toMonth?: string, testId?: string, locale?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('getQuestionStatistics', 'questionId', questionId)
            const localVarPath = `/api/v1/questions/{questionId}/statistics`
                .replace(`{${"questionId"}}`, encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fromMonth !== undefined) {
                localVarQueryParameter['fromMonth'] = fromMonth;
            }

            if (toMonth !== undefined) {
                localVarQueryParameter['toMonth'] = toMonth;
            }

            if (testId !== undefined) {
                localVarQueryParameter['testId'] = testId;
            }

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The measures of rankQuestions summed over the questions of a category, for each category with a question asked in the period, in the order of the categories. A question counts in the category it is in today.
         * @summary How the questions of each category fare
         * @param {string} [fromMonth] The first month counted, as 2026-01. Leave it out to count from the start.
         * @param {string} [toMonth] The last month counted, whole. Leave it out to count up to now.
         * @param {string} [testId] Only attempts at this test.
         * @param {QuestionTypeDto} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCategoryStatistics: async (fromMonth?: string, toMonth?: string, testId?: string, type?: QuestionTypeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/questions/statistics/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fromMonth !== undefined) {
                localVarQueryParameter['fromMonth'] = fromMonth;
            }

            if (toMonth !== undefined) {
                localVarQueryParameter['toMonth'] = toMonth;
            }

            if (testId !== undefined) {
                localVarQueryParameter['testId'] = testId;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Every question asked in an attempt that counts — finished or ended by its time limit, in a test or in an exam. An attempt still running counts once it ends; one invalidated stops counting. A question shows once, over all its versions, with the wording of its current version. The period is in months, by the month an attempt was started in Polish time.
         * @summary How the questions fare in tests and exams, the hardest first
         * @param {string} [fromMonth] The first month counted, as 2026-01. Leave it out to count from the start.
         * @param {string} [toMonth] The last month counted, whole. Leave it out to count up to now.
         * @param {string} [testId] Only attempts at this test.
         * @param {string} [categoryId] 
         * @param {QuestionTypeDto} [type] 
         * @param {number} [minAsked] Only questions asked at least this many times in the period — a question asked twice says little by its percent.
         * @param {string} [locale] Language of the wording, where the version has it; otherwise its source language. A tag of a real language, such as pl or pt-BR.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sort] Field and direction: correctPercent, averagePercent, asked or businessKey, then asc or desc. Defaults to the lowest percent of correct answers first. Ties go by key.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rankQuestions: async (fromMonth?: string, toMonth?: string, testId?: string, categoryId?: string, type?: QuestionTypeDto, minAsked?: number, locale?: string, page?: number, size?: number, sort?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/questions/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fromMonth !== undefined) {
                localVarQueryParameter['fromMonth'] = fromMonth;
            }

            if (toMonth !== undefined) {
                localVarQueryParameter['toMonth'] = toMonth;
            }

            if (testId !== undefined) {
                localVarQueryParameter['testId'] = testId;
            }

            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (minAsked !== undefined) {
                localVarQueryParameter['minAsked'] = minAsked;
            }

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuestionStatisticsApi - functional programming interface
 * @export
 */
export const QuestionStatisticsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QuestionStatisticsApiAxiosParamCreator(configuration)
    return {
        /**
         * Every question rankQuestions finds for these filters, on all its pages and in its order, on the sheet \"pytania\"; the categories as listCategoryStatistics gives them, for the same period, test and type, on the sheet \"kategorie\".
         * @summary The ranking and the categories as a spreadsheet
         * @param {string} [fromMonth] The first month counted, as 2026-01. Leave it out to count from the start.
         * @param {string} [toMonth] The last month counted, whole. Leave it out to count up to now.
         * @param {string} [testId] Only attempts at this test.
         * @param {string} [categoryId] 
         * @param {QuestionTypeDto} [type] 
         * @param {number} [minAsked] 
         * @param {string} [locale] Language of the wording, where the version has it; otherwise its source language. A tag of a real language, such as pl or pt-BR.
         * @param {string} [sort] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportQuestionRanking(fromMonth?: string, toMonth?: string, testId?: string, categoryId?: string, type?: QuestionTypeDto, minAsked?: number, locale?: string, sort?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportQuestionRanking(fromMonth, toMonth, testId, categoryId, type, minAsked, locale, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionStatisticsApi.exportQuestionRanking']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Counted as for rankQuestions. Versions newest first, only those asked in the period. A choice question has, for each version, how many times each answer was chosen. A question not asked yet answers with zeros and no versions.
         * @summary How one question fares, in all and version by version
         * @param {string} questionId 
         * @param {string} [fromMonth] The first month counted, as 2026-01. Leave it out to count from the start.
         * @param {string} [toMonth] The last month counted, whole. Leave it out to count up to now.
         * @param {string} [testId] Only attempts at this test.
         * @param {string} [locale] Language of the wording, where the version has it; otherwise its source language. A tag of a real language, such as pl or pt-BR.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuestionStatistics(questionId: string, fromMonth?: string, toMonth?: string, testId?: string, locale?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionStatisticsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuestionStatistics(questionId, fromMonth, toMonth, testId, locale, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionStatisticsApi.getQuestionStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The measures of rankQuestions summed over the questions of a category, for each category with a question asked in the period, in the order of the categories. A question counts in the category it is in today.
         * @summary How the questions of each category fare
         * @param {string} [fromMonth] The first month counted, as 2026-01. Leave it out to count from the start.
         * @param {string} [toMonth] The last month counted, whole. Leave it out to count up to now.
         * @param {string} [testId] Only attempts at this test.
         * @param {QuestionTypeDto} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCategoryStatistics(fromMonth?: string, toMonth?: string, testId?: string, type?: QuestionTypeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CategoryStatisticsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCategoryStatistics(fromMonth, toMonth, testId, type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionStatisticsApi.listCategoryStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Every question asked in an attempt that counts — finished or ended by its time limit, in a test or in an exam. An attempt still running counts once it ends; one invalidated stops counting. A question shows once, over all its versions, with the wording of its current version. The period is in months, by the month an attempt was started in Polish time.
         * @summary How the questions fare in tests and exams, the hardest first
         * @param {string} [fromMonth] The first month counted, as 2026-01. Leave it out to count from the start.
         * @param {string} [toMonth] The last month counted, whole. Leave it out to count up to now.
         * @param {string} [testId] Only attempts at this test.
         * @param {string} [categoryId] 
         * @param {QuestionTypeDto} [type] 
         * @param {number} [minAsked] Only questions asked at least this many times in the period — a question asked twice says little by its percent.
         * @param {string} [locale] Language of the wording, where the version has it; otherwise its source language. A tag of a real language, such as pl or pt-BR.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sort] Field and direction: correctPercent, averagePercent, asked or businessKey, then asc or desc. Defaults to the lowest percent of correct answers first. Ties go by key.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rankQuestions(fromMonth?: string, toMonth?: string, testId?: string, categoryId?: string, type?: QuestionTypeDto, minAsked?: number, locale?: string, page?: number, size?: number, sort?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionRankingPageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rankQuestions(fromMonth, toMonth, testId, categoryId, type, minAsked, locale, page, size, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionStatisticsApi.rankQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * QuestionStatisticsApi - factory interface
 * @export
 */
export const QuestionStatisticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QuestionStatisticsApiFp(configuration)
    return {
        /**
         * Every question rankQuestions finds for these filters, on all its pages and in its order, on the sheet \"pytania\"; the categories as listCategoryStatistics gives them, for the same period, test and type, on the sheet \"kategorie\".
         * @summary The ranking and the categories as a spreadsheet
         * @param {string} [fromMonth] The first month counted, as 2026-01. Leave it out to count from the start.
         * @param {string} [toMonth] The last month counted, whole. Leave it out to count up to now.
         * @param {string} [testId] Only attempts at this test.
         * @param {string} [categoryId] 
         * @param {QuestionTypeDto} [type] 
         * @param {number} [minAsked] 
         * @param {string} [locale] Language of the wording, where the version has it; otherwise its source language. A tag of a real language, such as pl or pt-BR.
         * @param {string} [sort] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportQuestionRanking(fromMonth?: string, toMonth?: string, testId?: string, categoryId?: string, type?: QuestionTypeDto, minAsked?: number, locale?: string, sort?: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.exportQuestionRanking(fromMonth, toMonth, testId, categoryId, type, minAsked, locale, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * Counted as for rankQuestions. Versions newest first, only those asked in the period. A choice question has, for each version, how many times each answer was chosen. A question not asked yet answers with zeros and no versions.
         * @summary How one question fares, in all and version by version
         * @param {string} questionId 
         * @param {string} [fromMonth] The first month counted, as 2026-01. Leave it out to count from the start.
         * @param {string} [toMonth] The last month counted, whole. Leave it out to count up to now.
         * @param {string} [testId] Only attempts at this test.
         * @param {string} [locale] Language of the wording, where the version has it; otherwise its source language. A tag of a real language, such as pl or pt-BR.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionStatistics(questionId: string, fromMonth?: string, toMonth?: string, testId?: string, locale?: string, options?: RawAxiosRequestConfig): AxiosPromise<QuestionStatisticsDto> {
            return localVarFp.getQuestionStatistics(questionId, fromMonth, toMonth, testId, locale, options).then((request) => request(axios, basePath));
        },
        /**
         * The measures of rankQuestions summed over the questions of a category, for each category with a question asked in the period, in the order of the categories. A question counts in the category it is in today.
         * @summary How the questions of each category fare
         * @param {string} [fromMonth] The first month counted, as 2026-01. Leave it out to count from the start.
         * @param {string} [toMonth] The last month counted, whole. Leave it out to count up to now.
         * @param {string} [testId] Only attempts at this test.
         * @param {QuestionTypeDto} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCategoryStatistics(fromMonth?: string, toMonth?: string, testId?: string, type?: QuestionTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<Array<CategoryStatisticsDto>> {
            return localVarFp.listCategoryStatistics(fromMonth, toMonth, testId, type, options).then((request) => request(axios, basePath));
        },
        /**
         * Every question asked in an attempt that counts — finished or ended by its time limit, in a test or in an exam. An attempt still running counts once it ends; one invalidated stops counting. A question shows once, over all its versions, with the wording of its current version. The period is in months, by the month an attempt was started in Polish time.
         * @summary How the questions fare in tests and exams, the hardest first
         * @param {string} [fromMonth] The first month counted, as 2026-01. Leave it out to count from the start.
         * @param {string} [toMonth] The last month counted, whole. Leave it out to count up to now.
         * @param {string} [testId] Only attempts at this test.
         * @param {string} [categoryId] 
         * @param {QuestionTypeDto} [type] 
         * @param {number} [minAsked] Only questions asked at least this many times in the period — a question asked twice says little by its percent.
         * @param {string} [locale] Language of the wording, where the version has it; otherwise its source language. A tag of a real language, such as pl or pt-BR.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sort] Field and direction: correctPercent, averagePercent, asked or businessKey, then asc or desc. Defaults to the lowest percent of correct answers first. Ties go by key.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rankQuestions(fromMonth?: string, toMonth?: string, testId?: string, categoryId?: string, type?: QuestionTypeDto, minAsked?: number, locale?: string, page?: number, size?: number, sort?: string, options?: RawAxiosRequestConfig): AxiosPromise<QuestionRankingPageDto> {
            return localVarFp.rankQuestions(fromMonth, toMonth, testId, categoryId, type, minAsked, locale, page, size, sort, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QuestionStatisticsApi - interface
 * @export
 * @interface QuestionStatisticsApi
 */
export interface QuestionStatisticsApiInterface {
    /**
     * Every question rankQuestions finds for these filters, on all its pages and in its order, on the sheet \"pytania\"; the categories as listCategoryStatistics gives them, for the same period, test and type, on the sheet \"kategorie\".
     * @summary The ranking and the categories as a spreadsheet
     * @param {string} [fromMonth] The first month counted, as 2026-01. Leave it out to count from the start.
     * @param {string} [toMonth] The last month counted, whole. Leave it out to count up to now.
     * @param {string} [testId] Only attempts at this test.
     * @param {string} [categoryId] 
     * @param {QuestionTypeDto} [type] 
     * @param {number} [minAsked] 
     * @param {string} [locale] Language of the wording, where the version has it; otherwise its source language. A tag of a real language, such as pl or pt-BR.
     * @param {string} [sort] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionStatisticsApiInterface
     */
    exportQuestionRanking(fromMonth?: string, toMonth?: string, testId?: string, categoryId?: string, type?: QuestionTypeDto, minAsked?: number, locale?: string, sort?: string, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * Counted as for rankQuestions. Versions newest first, only those asked in the period. A choice question has, for each version, how many times each answer was chosen. A question not asked yet answers with zeros and no versions.
     * @summary How one question fares, in all and version by version
     * @param {string} questionId 
     * @param {string} [fromMonth] The first month counted, as 2026-01. Leave it out to count from the start.
     * @param {string} [toMonth] The last month counted, whole. Leave it out to count up to now.
     * @param {string} [testId] Only attempts at this test.
     * @param {string} [locale] Language of the wording, where the version has it; otherwise its source language. A tag of a real language, such as pl or pt-BR.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionStatisticsApiInterface
     */
    getQuestionStatistics(questionId: string, fromMonth?: string, toMonth?: string, testId?: string, locale?: string, options?: RawAxiosRequestConfig): AxiosPromise<QuestionStatisticsDto>;

    /**
     * The measures of rankQuestions summed over the questions of a category, for each category with a question asked in the period, in the order of the categories. A question counts in the category it is in today.
     * @summary How the questions of each category fare
     * @param {string} [fromMonth] The first month counted, as 2026-01. Leave it out to count from the start.
     * @param {string} [toMonth] The last month counted, whole. Leave it out to count up to now.
     * @param {string} [testId] Only attempts at this test.
     * @param {QuestionTypeDto} [type] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionStatisticsApiInterface
     */
    listCategoryStatistics(fromMonth?: string, toMonth?: string, testId?: string, type?: QuestionTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<Array<CategoryStatisticsDto>>;

    /**
     * Every question asked in an attempt that counts — finished or ended by its time limit, in a test or in an exam. An attempt still running counts once it ends; one invalidated stops counting. A question shows once, over all its versions, with the wording of its current version. The period is in months, by the month an attempt was started in Polish time.
     * @summary How the questions fare in tests and exams, the hardest first
     * @param {string} [fromMonth] The first month counted, as 2026-01. Leave it out to count from the start.
     * @param {string} [toMonth] The last month counted, whole. Leave it out to count up to now.
     * @param {string} [testId] Only attempts at this test.
     * @param {string} [categoryId] 
     * @param {QuestionTypeDto} [type] 
     * @param {number} [minAsked] Only questions asked at least this many times in the period — a question asked twice says little by its percent.
     * @param {string} [locale] Language of the wording, where the version has it; otherwise its source language. A tag of a real language, such as pl or pt-BR.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sort] Field and direction: correctPercent, averagePercent, asked or businessKey, then asc or desc. Defaults to the lowest percent of correct answers first. Ties go by key.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionStatisticsApiInterface
     */
    rankQuestions(fromMonth?: string, toMonth?: string, testId?: string, categoryId?: string, type?: QuestionTypeDto, minAsked?: number, locale?: string, page?: number, size?: number, sort?: string, options?: RawAxiosRequestConfig): AxiosPromise<QuestionRankingPageDto>;

}

/**
 * QuestionStatisticsApi - object-oriented interface
 * @export
 * @class QuestionStatisticsApi
 * @extends {BaseAPI}
 */
export class QuestionStatisticsApi extends BaseAPI implements QuestionStatisticsApiInterface {
    /**
     * Every question rankQuestions finds for these filters, on all its pages and in its order, on the sheet \"pytania\"; the categories as listCategoryStatistics gives them, for the same period, test and type, on the sheet \"kategorie\".
     * @summary The ranking and the categories as a spreadsheet
     * @param {string} [fromMonth] The first month counted, as 2026-01. Leave it out to count from the start.
     * @param {string} [toMonth] The last month counted, whole. Leave it out to count up to now.
     * @param {string} [testId] Only attempts at this test.
     * @param {string} [categoryId] 
     * @param {QuestionTypeDto} [type] 
     * @param {number} [minAsked] 
     * @param {string} [locale] Language of the wording, where the version has it; otherwise its source language. A tag of a real language, such as pl or pt-BR.
     * @param {string} [sort] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionStatisticsApi
     */
    public exportQuestionRanking(fromMonth?: string, toMonth?: string, testId?: string, categoryId?: string, type?: QuestionTypeDto, minAsked?: number, locale?: string, sort?: string, options?: RawAxiosRequestConfig) {
        return QuestionStatisticsApiFp(this.configuration).exportQuestionRanking(fromMonth, toMonth, testId, categoryId, type, minAsked, locale, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Counted as for rankQuestions. Versions newest first, only those asked in the period. A choice question has, for each version, how many times each answer was chosen. A question not asked yet answers with zeros and no versions.
     * @summary How one question fares, in all and version by version
     * @param {string} questionId 
     * @param {string} [fromMonth] The first month counted, as 2026-01. Leave it out to count from the start.
     * @param {string} [toMonth] The last month counted, whole. Leave it out to count up to now.
     * @param {string} [testId] Only attempts at this test.
     * @param {string} [locale] Language of the wording, where the version has it; otherwise its source language. A tag of a real language, such as pl or pt-BR.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionStatisticsApi
     */
    public getQuestionStatistics(questionId: string, fromMonth?: string, toMonth?: string, testId?: string, locale?: string, options?: RawAxiosRequestConfig) {
        return QuestionStatisticsApiFp(this.configuration).getQuestionStatistics(questionId, fromMonth, toMonth, testId, locale, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The measures of rankQuestions summed over the questions of a category, for each category with a question asked in the period, in the order of the categories. A question counts in the category it is in today.
     * @summary How the questions of each category fare
     * @param {string} [fromMonth] The first month counted, as 2026-01. Leave it out to count from the start.
     * @param {string} [toMonth] The last month counted, whole. Leave it out to count up to now.
     * @param {string} [testId] Only attempts at this test.
     * @param {QuestionTypeDto} [type] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionStatisticsApi
     */
    public listCategoryStatistics(fromMonth?: string, toMonth?: string, testId?: string, type?: QuestionTypeDto, options?: RawAxiosRequestConfig) {
        return QuestionStatisticsApiFp(this.configuration).listCategoryStatistics(fromMonth, toMonth, testId, type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Every question asked in an attempt that counts — finished or ended by its time limit, in a test or in an exam. An attempt still running counts once it ends; one invalidated stops counting. A question shows once, over all its versions, with the wording of its current version. The period is in months, by the month an attempt was started in Polish time.
     * @summary How the questions fare in tests and exams, the hardest first
     * @param {string} [fromMonth] The first month counted, as 2026-01. Leave it out to count from the start.
     * @param {string} [toMonth] The last month counted, whole. Leave it out to count up to now.
     * @param {string} [testId] Only attempts at this test.
     * @param {string} [categoryId] 
     * @param {QuestionTypeDto} [type] 
     * @param {number} [minAsked] Only questions asked at least this many times in the period — a question asked twice says little by its percent.
     * @param {string} [locale] Language of the wording, where the version has it; otherwise its source language. A tag of a real language, such as pl or pt-BR.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sort] Field and direction: correctPercent, averagePercent, asked or businessKey, then asc or desc. Defaults to the lowest percent of correct answers first. Ties go by key.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionStatisticsApi
     */
    public rankQuestions(fromMonth?: string, toMonth?: string, testId?: string, categoryId?: string, type?: QuestionTypeDto, minAsked?: number, locale?: string, page?: number, size?: number, sort?: string, options?: RawAxiosRequestConfig) {
        return QuestionStatisticsApiFp(this.configuration).rankQuestions(fromMonth, toMonth, testId, categoryId, type, minAsked, locale, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }
}

